import * as Yup from 'yup'

export const getInitialValues = ({ primary_location_id }) => ({
    primary_location_id: primary_location_id || null,
})

export const validationSchema = Yup.object().shape({
    primary_location_id: Yup.number().required('The location is required'),
})
